const m = window.require("@ember/object/evented");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;